import Icon from '@ant-design/icons';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { UnixToDate } from '../../../../_config/utils/unix-to-date.util';
import { ColumnTitles } from '../constants/column-titles.constant';
import { typeDelivery } from './type-delivery.handle';
import { handleNotificationClick } from '../../../../_config/functions/check-notification-and-mark-as-read';

export const generateColumns = (itemsDropdownDelivery, itemsDropdownSelect, status) => {
	return [
		{
			title: ColumnTitles[Enviroment.LANGUAGE].trx_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].operation_id,
			dataIndex: 'short_code',
			key: 'short_code',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].pharmacy,
			dataIndex: 'pharmacy',
			key: 'pharmacy',
		},
		{
			// title: dropdownOptionsDelivery(itemsDropdownDelivery),
			title: ColumnTitles[Enviroment.LANGUAGE].quotation_type,
			dataIndex: 'quotation_type',
			key: 'quotation_type',

			render: (deliveryType) => typeDelivery(deliveryType),
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].createdAt,
			dataIndex: 'created_at',
			key: 'created_at',

			render: (createdAt) => UnixToDate(createdAt),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].detailOrder,
			dataIndex: 'detailOrder',
			key: 'detailOrder',
			render: (_, record) => {
				console.log('record',record)
				return (
					<Link
						to={`/admin-quotation/detail/${record?._id}`}
					  onClick={() => handleNotificationClick(record?.short_code, record?.pharmacy[0])}
					>
						<Icon className="link-voucher" component={SearchOutlined} />
					</Link>
				);
			},
		},
	];
};
